import { http } from '@/http/axios.js'

export function getQiniuToken() {
  return http({
    url: `/api/admin/file/getUploadConf`,
    method: 'get'
  })
}
